/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ValueAccessor } from './value.accessor';

const NUMBER_VALUE_SELECTOR_LIST = `
  dcr-text-field[formControl][type="number"],
  dcr-text-field[formControlName][type="number"],
  dcr-text-field[ngModel][type="number"],

  dcr-select[formControl][valueAsNumber]:not([multiple]),
  dcr-select[formControlName][valueAsNumber]:not([multiple]),
  dcr-select[ngModel][valueAsNumber]:not([multiple]),

  dcr-filter-chip[formControl][valueAsNumber]:not([multiple]),
  dcr-filter-chip[formControlName][valueAsNumber]:not([multiple]),
  dcr-filter-chip[ngModel][valueAsNumber]:not([multiple]),

  dcr-radio-group[formControl][valueAsNumber],
  dcr-radio-group[formControlName][valueAsNumber],
  dcr-radio-group[ngModel][valueAsNumber],
`;

@Directive({
    /* tslint:disable-next-line:directive-selector */
    selector: NUMBER_VALUE_SELECTOR_LIST,
    host: {
        '(input)': 'handleChangeEvent($event.target.value)',
        '(change)': 'handleChangeEvent($event.target.value)',
        '(focusout)': 'handleBlurEvent()',
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NumberValueAccessor,
            multi: true,
        },
    ],
    standalone: false
})
export class NumberValueAccessor extends ValueAccessor {
  override writeValue(value: any): void {
    if (this.lastValue !== value) {
      this._element.nativeElement.value = this.lastValue = value == null ? '' : value.toString();
    }
  }

  override registerOnChange(fn: (_: number | null) => void) {
    super.registerOnChange((value: string) => {
      fn(value === '' ? null : parseFloat(value));
    });
  }
}
